
import { Booking, DayOfWeek } from "@/models/Schedule";
import { timeSlots } from "./timeSlotsData";
import { clients } from "./clientsData";

// Helper function to generate dates for the next 4 weeks
function generateUpcomingDates(today = new Date()): Date[] {
  const dates: Date[] = [];
  const daysToGenerate = 28; // 4 weeks
  
  for (let i = 0; i < daysToGenerate; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);
    dates.push(date);
  }
  
  return dates;
}

// Helper to get day name from date
function getDayName(date: Date): DayOfWeek {
  const days: DayOfWeek[] = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
  return days[date.getDay()];
}

// Generate bookings for the next 4 weeks
export function generateBookings(): Booking[] {
  const bookings: Booking[] = [];
  const upcomingDates = generateUpcomingDates();
  let bookingId = 1;
  
  upcomingDates.forEach(date => {
    const dayName = getDayName(date);
    const daySlots = timeSlots.filter(slot => slot.day === dayName);
    
    // For each time slot on this day, create some random bookings
    daySlots.forEach(slot => {
      // Randomly decide if we should create a booking for this client and slot
      clients.forEach(client => {
        if (Math.random() > 0.7) { // 30% chance of booking
          bookings.push({
            id: `b${bookingId++}`,
            timeSlotId: slot.id,
            clientId: client.id,
            date: new Date(date),
            status: 'booked',
            createdAt: new Date(),
            updatedAt: new Date(),
          });
        }
      });
    });
  });
  
  return bookings;
}

// Generate initial bookings
export const bookings: Booking[] = generateBookings();
